import React from 'react';

// Create a context with no initial values.
export const TicketTypesContext = React.createContext();

export default TicketTypesContext;
